export default __webpack_public_path__ + "63f41f1aee793a8665991348c87017bc.png";